/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { PureComponent } from 'react';
import { css } from 'aphrodite';
import { colors, IndicatorProps, Switch } from '@blend/consumer-components';

import { createStyles } from './style';

export type SmallToggleProps = React.InputHTMLAttributes<HTMLInputElement> & { label?: string | JSX.Element };

const styles = createStyles(colors.reflex);

function Indicator({ checked, focused, color, ...props }: IndicatorProps) {
  const classes = [styles.indicator, checked && styles.checked, focused && styles.focused];
  return (
    <div {...props} className={css(...classes)}>
      {checked ? (
        <span className={css(styles.icon, styles.yes)} data-axe-exception="Toggle">
          ON
        </span>
      ) : (
        <span className={css(styles.icon, styles.no)} data-axe-exception="Toggle">
          OFF
        </span>
      )}
    </div>
  );
}

export default class SmallToggle extends PureComponent<SmallToggleProps> {
  render() {
    return (
      <div className={css(styles.toggle, styles.noBorder)}>
        <Switch
          {...this.props}
          type="checkbox"
          labelPosition="left"
          indicatorComponent={Indicator}
          color={colors.reflex}
        />
      </div>
    );
  }
}
